// extracted by mini-css-extract-plugin
export default {"bank_cards_container":"BankCards_bank_cards_container__1XI6q"};